import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { chatComplete, storeMessage } from 'app/requests/chats';
import { useTranslation } from 'next-i18next';
import { AppStoreState } from 'app/redux/store';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import { uuid } from 'app/utils/string';
import ChatHeader from './ChatHeader';
import ChatToggle from './ChatToggle';
import ChatStyles from './ChatStyles';
import { Message } from 'types/chat';
import Messages from './Messages';

const ChatPopup = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { messages } = useSelector((state: AppStoreState) => state.global);
  const [listMessages, setListMessages] = useState<Message[]>([
    {
      key: uuid(),
      content: 'Hello! How can I help you?',
      sender: 'bot'
    },
    ...messages,
  ]);

  const [newMessage, setNewMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);

  // Simulate bot response
  const sendQuestion = async (question: string) => {
    const content = await chatComplete(question);
    const botMessage = { key: uuid(), content, sender: 'bot' };

    setListMessages(prev => [...prev, botMessage]);
    storeMessage(botMessage);
    setIsTyping(false);
  };

  const handleSendMessage = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    setIsTyping(true);

    const userMessage = { key: uuid(), content: newMessage, sender: 'user' };
    storeMessage(userMessage);
    setListMessages(prev => [...prev, userMessage]);

    sendQuestion(newMessage);
    setNewMessage('');
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="chat-popup-container">
      <ChatToggle toggle={toggleChat} isOpen={isOpen} />

      {/* Chat Window */}
      {isOpen && (
        <div className="chat-window position-fixed bg-white border rounded shadow d-flex flex-column">
          {/* Chat Header */}
          <ChatHeader toggleChat={toggleChat} />

          {/* List Messages */}
          <Messages
            messages={listMessages}
            isTyping={isTyping}
            isOpen={isOpen}
          />

          {/* Message Input */}
          <form onSubmit={handleSendMessage} className="p-3 border-top">
            <div className="input-group">
              <input
                type="text"
                value={newMessage}
                autoFocus={true}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder={t('comments.enter_message')}
                className="form-control"
                style={{ borderRadius: "20px 0 0 20px" }}
              />
              <button
                type="submit"
                className="btn btn-info"
                style={{ borderRadius: "0 20px 20px 0" }}
                disabled={!newMessage.trim()}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </div>
          </form>
        </div>
      )}

      <ChatStyles />
    </div>
  );
};

export default ChatPopup;
